import React, {Fragment, useEffect} from "react"
import { useNavigate } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';
import i18n from '../i18n';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

function withHooks(WrappedComponent) {
    return function(props) {
        const nav = useNavigate();
        return <WrappedComponent nav={nav} {...props}/>
    };
}

class Itom extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'current_id': '',
            'item_id': '',
            'event_id': '',
            'new_id': '',
            'new_text': '',
            'new_description': '',
            'new_pud_date': '',
            'new_text_1': '',
            'new_description_1': '',
            'new_pud_date_1': '',
            'title': '',
            'text': '',
            'event_text': '',
            'event_data': '',
            'event_old_data': '',
            'event_img': '',
            'item_data': '',
            'item_old_data': '',
            'item_audio': '',
            'source':  '',
            'author': '',
            'tags': '',
            'versuch_count': 0,
        };
    }

    handleNickChange = (e) => {
        this.setState({name: e.target.value});
    };

    handleLangChange = (e) => {
        this.setState({lang: e.target.value});
        i18n.language = e.target.value;
       // console.log(i18n.language);
    };

    randomNumberInRange = (min, max) => {
        const minCeiled = Math.ceil(min);
        const maxFloored = Math.floor(max);
        //console.log(minCeiled,maxFloored,Math.random());
        return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
        //return Math.floor(Math.random() * max);
    };

    getManyNews(id) {
        fetch('https://api.roomab.art/get-many-news-by-id?id='+id)
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    many_new_id: data.id,
                    many_new_text: data.text,
                    many_new_description: data.description,
                    many_new_pud_date: data.pud_date,
                }))
            });
    }

    getNews(id) {
        fetch('https://api.roomab.art/get-news-by-id?id='+id)
        // fetch('https://api.roomab.art/'
        .then(response => response.json())
        .then(data => {
            //this.getAnswers(data)
            console.log(data)

            this.setState(state =>({
                new_id: data.id,
                new_text: data.text,
                new_description: data.description,
                new_pud_date: data.pud_date,
            }))
        });
    }

    getEvent(id) {

        fetch('https://api.roomab.art/get-event-by-id?id='+id)
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    event_id: data.id,
                    event_text: data.text,
                    event_data: data.data,
                    event_old_data: data.old_data,
                    event_img: data.img
                }))
            });
    }

    getMatch(id) {
        /*
        {"date":"24.04.2021","time":"21:00","tournament":"Алжир: Лига 2","host":"УСМ Блида","guest":"ЖСМ де Биджайя",
        "gett":0,"lett":1,"stay_h":"","stay_g":"","yel_kart_h":"","yel_kart_g":"","red_kart_h":"","red_kart_g":"",
        "substit_h":"","substit_g":"","goul_h":"","goul_g":"17' ,","pen_miss_h":"","pen_miss_g":"","prim":"","info":"",
        "stra_h":"","stra_g":"","ud_h":0,"ud_g":0,"offside_h":0,"offside_g":0,"corner_h":0,"corner_g":0,"saves_h":0,"saves_g":0,
        "yelkar_h":"","yelkar_g":"","ballpos_h":0,"ballpos_g":0,"shtaf_h":0,"shraf_g":0,
        "outs_h":0,"outs_g":0,"bet_h":2.93,"bet_n":2.94,"bet_g":2.51,"coach_h":false,"coach_g":false}
         */

        fetch('https://api.roomab.art/get-match-by-id?id='+id)
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    match_id: data.id,
                    match_date: data.date,
                    match_tournament: data.tournament,
                    match_host: data.host,
                    match_guest: data.guest,
                    match_gett: data.gett,
                    match_lett: data.lett,
                    match_goul_h: data.goul_h,
                    match_goul_g: data.goul_g,
                    match_prim: data.prim,
                    match_info: data.info
                }))
            });
    }

    getItem(id) {

        fetch('https://api.roomab.art/get-item-by-id?id=' + id)
            // fetch('https://api.roomab.art/'
            .then(response => response.json())
            .then(data => {
                //this.getAnswers(data)
                console.log(data)

                this.setState(state =>({
                    item_id: data.id,
                    title: data.title,
                    text: data.text,
                    tags: data.tags,
                    source: data.source,
                    author: data.author,
                    item_audio: data.audio,
                    item_data: data.data,
                    item_old_data: data.old_data,
                    item_img: data.img
                }))
            });
    }

    componentDidMount() {
        this.getItem(1);
        this.getEvent(1)
        this.getNews(1)
        this.getManyNews(1)
        this.getMatch(1)

       /* fetch('https://api.roomab.art/bunt-item-by-id?id='+
            (localStorage.getItem('item_id') ||
                String(this.randomNumberInRange(0,localStorage.getItem('max_id')))))
            .then(response => response.json())
            .then(data => {
                localStorage.setItem('item_id', data[0].id);
                localStorage.setItem('max_id', data.max_id);
this.getItem(data[0].id);
                this.getEvent(data['events'][0].id)
                this.getNews(data['news'][0].id)
                this.getManyNews(data['many_news'][0].id)
        */



      /*      })
            .catch((error) => {
                console.log(error)
                localStorage.setItem('item_id', String(this.randomNumberInRange(0,70946)));
                //this.componentDidMount();
            });*/
    }

    handleRefresh = () => {
        window.location.reload();
    };


    render() {
        console.log(this.state.item_audio);
        return (
            <header className="App-header d-grid gap-2">
                <div id="block">
                    <div className="container-fluid" id="tablo">
                        <h4 className="title">{this.state.title}</h4>
                        <a href={'http://88.85.67.159:8093/rockncontroll/item/add-tag/'+this.state.item_id}
                             target="_blank">{this.state.item_id}</a>
                        <p style={{color: 'orange'}}>{this.state.author} - {this.state.source}</p>
                        <p style={{fontSize: "small", color: 'gray'}}>{this.state.tags}</p>
                        <p style={{ color: '#c46a44'}}>{this.state.item_data} ::
                            {(this.state.item_old_data !== "0") ? this.state.item_old_data : ''} </p>
                        <p style={{whiteSpace: "pre-wrap", color: 'lightgray'}}>{ReactHtmlParser(this.state.text)}</p>

                            {(this.state.item_img)
                                ? <p><img src={'https://static.roomab.art/'+this.state.item_img} alt=''/></p> : ''}
                            {(this.state.item_audio) ?
                                <AudioPlayer
                                    //autoPlay
                                    src={'https://static.roomab.art/'+this.state.item_audio}
                                    onPlay={e => console.log("onPlay")}
                                    //loop={true}
                                    // other props here
                                /> : ''}


                        <hr/>
                        <p style={{ color: '#c46a44'}}>{this.state.event_data} ::
                            {(this.state.event_old_data !== "0") ? this.state.event_old_data : ''} </p>
                        <p style={{whiteSpace: "pre-wrap", color: 'lightgray'}}>{ReactHtmlParser(this.state.event_text)}</p>
                        {(this.state.event_img)
                            ? <p><img src={'https://static.roomab.art/'+this.state.event_img} alt=''/></p> : ''}

                            <hr/>
                            <p style={{ color: '#c46a44'}}>{this.state.new_pud_date} </p>
                            <p style={{whiteSpace: "pre-wrap", color: 'lightgray'}}>
                                <span style={{whiteSpace: "pre-wrap", color: 'gray'}}>{ReactHtmlParser(this.state.new_text)}</span>
                               :: {ReactHtmlParser(this.state.new_description)}</p>

                        <hr />
                        <p style={{ color: '#c46a44'}}>{
                            this.state.match_date} :: {this.state.match_tournament} </p>
                        <p style={{whiteSpace: "pre-wrap", color: 'lightgray'}}>{this.state.match_host} - {this.state.match_guest} {this.state.match_gett}:
                            {this.state.match_lett} <span style={{color: "gray"}}>
                                {this.state.match_goul_h} - {this.state.match_goul_g}</span></p>
                        <p style={{ color: '#c46a44'}}>{this.state.match_prim}  {this.state.match_info} </p>
                        <hr />
                        <p style={{ color: '#c46a44'}}>{this.state.many_new_pud_date} </p>
                        <p style={{whiteSpace: "pre-wrap", color: 'lightgray'}}>
                            <span style={{whiteSpace: "pre-wrap", color: 'gray'}}>
                                {ReactHtmlParser(this.state.many_new_text)}</span>
                          ::  {ReactHtmlParser(this.state.many_new_description)}</p>
                            <div className="d-grid gap-2">
                            <button type="button"
                                    className={'btn btn-secondary btn-lg btn-block'}
                                    onClick={this.handleRefresh}>New
                            </button>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
export default withHooks(Itom)
